import * as React from "react";
const SvgFiRrWineGlassCrack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 9V3c0-1.654-1.346-3-3-3H8C6.346 0 5 1.346 5 3v6c0 3.52 2.612 6.441 6 6.928V22H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-6.072c3.388-.487 6-3.408 6-6.928M7 9V3c0-.552.449-1 1-1h3.069S9.101 4.814 9.07 4.917a1.62 1.62 0 0 0 .249 1.431c.303.408.788.652 1.297.652h2.068l-1.533 2.473a1 1 0 0 0 1.7 1.054l1.882-3.037a1.603 1.603 0 0 0-1.337-2.491h-1.998l2.121-3h2.482c.551 0 1 .448 1 1v6c0 2.757-2.243 5-5 5s-5-2.243-5-5z"
    />
  </svg>
);
export default SvgFiRrWineGlassCrack;
